<template>
  <sui-menu class="navbar">
    <div>
      <router-link to="/" class="home-link">
        <h1>
          <!-- AML Risk Proposal -->
          AML Clinical Support

          <!-- Logo 1-->
          <svg
            style="display: block"
            width="43"
            height="44"
            viewBox="0 0 43 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.6523 25.9986C24.0424 25.9986 25.9801 24.061 25.9801 21.6708C25.9801 19.2806 24.0424 17.343 21.6523 17.343C19.2621 17.343 17.3245 19.2806 17.3245 21.6708C17.3245 24.061 19.2621 25.9986 21.6523 25.9986Z"
              fill="#4CD4FF"
            />
            <path
              d="M35.6344 21.0466L37.4654 17.8008L43 17.8424L40.4616 22.1702L42.7503 26.7477L36.7996 26.6228L35.8425 23.2521L21.2778 22.9608L21.1113 20.7137L35.6344 21.0466Z"
              fill="#4CD4FF"
            />
            <path
              d="M39.5877 28.537C39.13 28.4954 38.6722 28.4954 38.2561 28.4538C38.0064 29.1196 37.6735 29.7438 37.3406 30.4096C32.5134 39.0652 21.5691 42.1862 12.9135 37.359C4.25791 32.5319 1.13691 21.5876 5.96406 12.932C10.7912 4.27638 21.7355 1.15538 30.3911 5.98253C34.4276 8.22966 37.2157 11.7668 38.6306 15.8033L42.5423 15.8449C41.0026 10.4768 37.4654 5.64962 32.1805 2.73669C21.7355 -3.08919 8.50248 0.697628 2.71822 11.1426C-3.06605 21.5876 0.67916 34.779 11.1241 40.6049C21.5691 46.4308 34.8022 42.6439 40.628 32.199C41.2938 31.0338 41.7932 29.827 42.2093 28.5786C42.0429 28.5786 41.918 28.5786 41.7932 28.5786C41.2522 28.6202 40.5032 28.5786 39.5877 28.537Z"
              fill="#EB2A4D"
            />
            <path
              d="M29.8501 26.0402C27.2701 30.6593 21.4026 32.3238 16.7835 29.7438C12.1644 27.1637 10.4998 21.2962 13.0799 16.6772C15.6599 12.0581 21.5274 10.3935 26.1465 12.9736C28.6017 14.3468 30.183 16.6355 30.8072 19.1324H34.594L34.5108 18.8827C33.8034 15.1375 31.5146 11.7252 27.8943 9.72772C21.4858 6.14897 13.3712 8.47932 9.79242 14.8878C6.21367 21.2962 8.54402 29.4109 14.9525 32.9896C21.3609 36.5684 29.5172 34.2796 33.0959 27.8712C33.5953 26.9973 33.9698 26.0818 34.2195 25.1247H30.3078C30.183 25.416 30.0165 25.7489 29.8501 26.0402Z"
              fill="white"
            />
          </svg>

          <!-- Logo 2-->
          <svg
            style="display: none"
            class="app-logo"
            width="41"
            height="43"
            viewBox="0 0 41 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.4999 36C27.508 36 33.9999 29.5081 33.9999 21.5C33.9999 13.4919 27.508 7 19.4999 7C14.2367 7 9.62848 9.80418 7.08774 14C5.76265 16.1883 9.49976 17.7551 9.49976 20.5C9.49976 23.5181 5.92203 27.3209 7.49991 29.642C10.1087 33.4794 14.5099 36 19.4999 36Z"
              fill="white"
            />
            <path
              d="M19.781 26.8414C22.7055 26.8414 25.0762 24.4414 25.0762 21.4808C25.0762 18.5202 22.7055 16.1201 19.781 16.1201C16.8566 16.1201 14.4858 18.5202 14.4858 21.4808C14.4858 24.4414 16.8566 26.8414 19.781 26.8414Z"
              fill="#F11139"
            />
            <path
              d="M19.7813 0C13.8052 0 8.35875 2.52716 4.50082 6.62422L9.90949 11.7551C12.4058 9.15138 15.9233 7.54319 19.7813 7.54319C27.3836 7.54319 33.5866 13.8228 33.5866 21.5191C33.5866 29.2155 27.3836 35.4951 19.7813 35.4951C15.772 35.4951 12.141 33.7337 9.60691 30.9386L4.19824 36.0695C8.09399 40.3197 13.6161 43 19.7813 43C31.4685 43 40.9999 33.3508 40.9999 21.5191C40.9999 9.68744 31.5063 0 19.7813 0Z"
              fill="#F11139"
            />
            <path
              d="M9.90958 11.7552L4.50092 6.62427C2.68542 8.53878 1.21033 10.7979 0.189114 13.3251L6.24077 19.0686L8.51014 21.2129L6.16512 23.4337L0 29.2538C0.983394 31.781 2.42066 34.0784 4.19834 36.0695L9.607 30.9386L19.857 21.2129L9.90958 11.7552Z"
              fill="#4DD4FF"
            />
            <g opacity="0.2">
              <path
                d="M4.19824 36.0695L19.8569 21.2129L6.01374 37.7926C6.01374 37.7926 4.76558 36.7205 4.19824 36.0695Z"
                fill="#6A6A71"
                style="mix-blend-mode:multiply"
              />
            </g>
          </svg>
        </h1>
      </router-link>
      <small>
        <a
          href="https://doi.org/10.1038/s41467-022-32103-8"
          target="_blank"
          class="paper-reference"
        >
          Tazi et al., Nature Comm 2022. Papaemmanuil Lab
        </a>
      </small>
    </div>
    <!-- <div class="paper-reference">
      <a
        href="mailto:Elli%20Papaemmanuil<papaemme@mskcc.org>?cc=Juanes%20Arango<arangooj@mskcc.org>&subject=[Contact]%20AML%20Clinical%20Support"
        target="_blank"
        class="text-md no-underline hover:text-blue-dark ml-2 px-1 cursor-pointer"
      >
        Contact
      </a>
    </div> -->
    <msk-logo class="logo" />
  </sui-menu>
</template>

<script>
import MskLogo from "@/assets/MskLogo";
export default {
  name: "NavBar",
  components: {
    MskLogo
  },
  computed: {
    selectedView() {
      return this.$route.name;
    }
  }
};
</script>

<style lang="scss">
.ui.menu.navbar .item {
  color: white;
  padding: 0 40px;
  font-size: 16px;
  &.menu-links {
    margin-left: 425px;
  }
  &.active,
  &:hover,
  &.active:hover {
    color: #fff;
    font-weight: 800;
    background: #3577d9;
  }
}

a.home-link,
a.home-link:hover {
  color: white;
}

a.paper-reference,
a.paper-reference:hover {
  // color: white;
  color: inherit;
  text-decoration: inherit;
}

.app-logo {
  height: 32px;
  margin-top: 5px;
}
</style>
